import { render, staticRenderFns } from "./FiltersGroupsIndex.vue?vue&type=template&id=2e6e4eff"
import script from "./FiltersGroupsIndex.vue?vue&type=script&lang=js"
export * from "./FiltersGroupsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports